import Vue from 'vue'
import VueRouter from 'vue-router'
import fichaClinicaRouter from './fichaClinica'
import avaliacaoPsicossocialRouter from './avaliacaoPsicossocial'
import loginRouter from './login'
import authenticationService from '@/services/authentication'
import atendimentoHibridoService from '@/services/atendimentoHibrido'
import store from '@/store'
Vue.use(VueRouter)

const validateTokenClinica = async (token, next) => {
  try {
    store.dispatch('app/showLoading')
    const { data } = await atendimentoHibridoService.validateTokenClinica(token)
    if (data.tokenValidated) {
      store.commit('app/SET_NOME_CLINICA', data.nomeClinica)
      next()
    }
  } catch (error) {
    console.log(error)
    next({ path: `/atendimento-hibrido/${token}` })
  } finally {
    store.dispatch('app/hideLoading')
  }
}

const routes = [
  {
    name: 'homepage',
    path: '/dashboard',
    beforeEnter: (to, from, next) => {
      if (authenticationService.isAuthenticated()) {
        next({ name: 'dashboard' })
      } else {
        this.$logoutDatadogUser()
        next({ name: 'Login' })
      }
    }
  },
  {
    name: 'LGPD',
    path: '/lgpd',
    component: () => import('@/views/lgpd.vue'),
    meta: { requiresAuth: false, appBar: false, footerMenu: false }
  },
  loginRouter,
  {
    name: 'inicio',
    path: '/inicio',
    component: () => import('@/views/Inicio.vue'),
    meta: { appBar: true, footerMenu: true }
  },
  {
    name: 'acessoRapido',
    path: '/cadastro/:token?',
    component: () => import('@/views/AcessoRapido/AcessoRapido.vue'),
    props: true
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: () => import('@/views/Dashboard/Dashboard.vue'),
    meta: { requiresAuth: true, appBar: true, footerMenu: true }
  },
  {
    name: 'agendamentos',
    path: '/agendamentos',
    component: () => import('@/views/Agendamento/Agendamento.vue'),
    meta: { requiresAuth: true, appBar: true, footerMenu: true }
  },
  {
    name: 'rede-beneficios',
    path: '/rede-beneficios',
    component: () => import('@/views/Rede/Rede-beneficios.vue'),
    meta: { requiresAuth: true, appBar: true, footerMenu: true }
  },
  {
    name: 'atestado',
    path: '/atestado',
    component: () => import('@/views/Upload/Atestado.vue'),
    meta: { requiresAuth: true, appBar: true, footerMenu: true }
  },
  {
    name: 'entregas-epi',
    path: '/entregas-epi',
    component: () => import('@/views/EntregasEpi/EntregasEpi.vue'),
    meta: { requiresAuth: true, appBar: true, footerMenu: true }
  },
  // {
  //   name: 'ambulatorio',
  //   path: '/ambulatorio-digital',
  //   component: () => import('@/views/Ambulatorio/AmbulatorioDigital.vue'),
  //   meta: { requiresAuth: true, appBar: true, footerMenu: true }
  // },
  // {
  //   name: 'fila-atendimento-ambulatorial',
  //   path: '/atendimento-ambulatorial/fila-atendimento/:idAtendimentoAmbulatorial',
  //   props: true,
  //   component: () => import('@/modules/AmbulatorioDigital/FilaAtendimento.vue'),
  //   meta: { requiresAuth: true, appBar: true, footerMenu: true }
  // },
  // {
  //   name: 'sala-atendimento-ambulatorial',
  //   path: '/atendimento-ambulatorial/sala-atendimento',
  //   props: true,
  //   component: () => import('@/modules/AmbulatorioDigital/Clinico/SalaAtendimento.vue'),
  //   meta: { requiresAuth: true, appBar: true, footerMenu: true }
  // },
  fichaClinicaRouter,
  ...avaliacaoPsicossocialRouter,
  {
    name: 'assinatura',
    path: '/assinatura',
    component: () => import('@/views/Assinatura/Assinatura.vue'),
    meta: { appBar: true, footerMenu: true },
    beforeEnter: (to, from, next) => {
      if (!authenticationService.isAuthenticated()) {
        next({ name: 'Login', query: { redirect: 'assinatura' } })
      } else {
        next()
      }
    }
  },
  {
    name: 'Agendar Exame',
    path: '/agendar-exame/:idAso?',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    props: true,
    component: () => import('@/views/AgendarExame.vue')
  },
  {
    name: 'minha-conta',
    path: '/minha-conta',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    component: () => import('@/views/MinhaConta/MinhaConta.vue')
  },
  {
    name: 'redefinir-senha',
    path: '/redefinir-senha',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    component: () => import('@/views/RedefinirSenha/RedefinirSenha.vue')
  },
  {
    name: 'meus-dados',
    path: '/meus-dados',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    component: () => import('@/views/MeusDados/MeusDados.vue')
  },
  {
    name: 'fila-atendimento',
    path: '/fila-atendimento/:idAsoMeetingRoom',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    props: true,
    component: () => import('@/modules/AtendimentoVirtual/FilaAtendimento.vue')
  },
  {
    name: 'sala-atendimento',
    path: '/sala-atendimento',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    props: true,
    component: () => import('@/modules/AtendimentoVirtual/SalaAtendimento.vue')
  },
  {
    name: 'sucesso-atendimento',
    path: '/sucesso-atendimento',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    props: true,
    component: () => import('@/modules/AtendimentoVirtual/SucessoAtendimento.vue')
  },
  {
    name: 'saude-mental',
    path: '/saude-mental',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    component: () => import('@/views/SaudeMental/SaudeMental.vue')
  },
  {
    name: 'saude-mental-sala',
    path: '/saude-mental/sala',
    meta: { appBar: true, requiresAuth: true, footerMenu: true },
    component: () => import('@/modules/SaudeMental/SalaAtendimento.vue')
  },
  {
    name: 'atendimento-hai',
    path: '/atendimento-hai',
    meta: { appBar: false, requiresAuth: false, footerMenu: false },
    props: true,
    component: () => import('@/views/AtendimentoHai/AtendimentoHai.vue'),
    children: [
      {
        name: 'erro-atendimento-hai',
        path: 'erro',
        props: true,
        component: () => import('@/modules/AtendimentoHai/ErroAtendimento.vue')
      },
      {
        name: 'verificacao-token-atendimento',
        path: '/',
        props: true,
        component: () => import('@/modules/AtendimentoHai/VerificacaoToken.vue')
      },
      {
        name: 'fila-atendimento-hai',
        path: 'fila-atendimento/:id',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('@/modules/AtendimentoHai/FilaAtendimentoHai.vue')
      },
      {
        name: 'sala-atendimento-hai',
        path: 'sala-atendimento',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('@/modules/AtendimentoHai/SalaAtendimentoHai.vue')
      },
      {
        name: 'sucesso-atendimento-hai',
        path: 'sucesso-atendimento',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('@/modules/AtendimentoHai/SucessoAtendimentoHai.vue')
      }
    ]
  },
  {
    path: '/atendimento-hibrido/:idClinica',
    meta: { appBar: false, requiresAuth: false, footerMenu: false },
    props: true,
    component: () => import('@/views/AtendimentoHibrido/AtendimentoHibrido.vue'),
    children: [
      {
        name: 'erro-atendimento-hibrido',
        path: 'erro',
        props: true,
        component: () => import('@/modules/AtendimentoHibrido/ErroAtendimento.vue')
      },
      {
        name: 'verificacao-cpf-atendimento',
        path: '/',
        props: true,
        component: () => import('@/modules/AtendimentoHibrido/VerificacaoCpf.vue'),
        beforeEnter: async (to, from, next) => {
          await validateTokenClinica(to.params.idClinica, next)
        }
      },
      {
        path: 'ficha-clinica',
        props: true,
        component: () => import('@/modules/AtendimentoHibrido/FichaClinica.vue'),
        meta: { appBar: false, requiresAuth: false, footerMenu: false },
        children: [
          {
            name: 'ficha-clinica-atendimento',
            path: 'bem-vindo',
            component: () => import('@/views/FichaClinica/FichaClinicaBemVindo.vue'),
            props: route => ({ onCancelRoute: `/atendimento-hibrido/${route.params.idClinica}` }),
            beforeEnter: async (to, from, next) => {
              await validateTokenClinica(to.params.idClinica, next)
            }
          },
          {
            path: 'dados',
            component: () => import('@/views/FichaClinica/FichaClinicaDados.vue'),
            props: true,
            beforeEnter: async (to, from, next) => {
              await validateTokenClinica(to.params.idClinica, next)
            }
          },
          {
            path: 'perguntas',
            component: () => import('@/views/FichaClinica/FichaClinicaPerguntas.vue'),
            props: true,
            beforeEnter: async (to, from, next) => {
              await validateTokenClinica(to.params.idClinica, next)
            }
          },
          {
            path: 'assinatura',
            component: () => import('@/views/FichaClinica/FichaClinicaAssinatura.vue'),
            props: true,
            beforeEnter: async (to, from, next) => {
              await validateTokenClinica(to.params.idClinica, next)
            }
          },
          {
            path: 'finalizar',
            props: true,
            component: () => import('@/modules/AtendimentoHibrido/FichaClinicaFinalizar.vue'),
            beforeEnter: async (to, from, next) => {
              await validateTokenClinica(to.params.idClinica, next)
            }
          }
        ]
      },
      {
        name: 'fila-atendimento-hibrido',
        path: 'fila-atendimento/:id',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('@/modules/AtendimentoHibrido/FilaAtendimentoHibrido.vue'),
        beforeEnter: async (to, from, next) => {
          await validateTokenClinica(to.params.idClinica, next)
        }
      },
      {
        name: 'sala-atendimento-hibrido',
        path: 'sala-atendimento',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('@/modules/AtendimentoHibrido/SalaAtendimentoHibrido.vue'),
        beforeEnter: async (to, from, next) => {
          await validateTokenClinica(to.params.idClinica, next)
        }
      },
      {
        name: 'sucesso-atendimento-hibrido',
        path: 'sucesso-atendimento',
        props: true,
        meta: { requiresAuth: true },
        component: () => import('@/modules/AtendimentoHibrido/SucessoAtendimentoHibrido.vue')
      }
    ]
  },
  {
    path: '*',
    redirect: '/login'
  }
]
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(m => m.meta.requiresAuth)
  if (requiresAuth && !authenticationService.isAuthenticated()) {
    next({
      name: 'Login',
      query: {
        ...to.query,
        redirect: to.path
      }
    })
  } else if (to.name === 'Agendar Exame' && !store.getters['user/enableTelemedicina']) {
    router.go(-1)
  } else {
    next()
  }
})

export default router
